var render, staticRenderFns
import script from "./Notif.vue?vue&type=script&lang=js"
export * from "./Notif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17080163')) {
      api.createRecord('17080163', component.options)
    } else {
      api.reload('17080163', component.options)
    }
    
  }
}
component.options.__file = "src/components/mixins/Notif.vue"
export default component.exports